// extracted by mini-css-extract-plugin
module.exports = {"dot":"_85ea12c","spinner":"_1ae29a6","ellipsis":"_d2f8624","odds":"_89f8a53"};